import { NavLink, Link } from 'react-router-dom';
import Logo from '../images/sfm-logo.svg';
import Trail from '../images/trial-icon.svg';
import Location from '../images/location.svg';
import Call from '../images/call.svg';
import Youtube from '../images/youtube.svg';
import Linkedin from '../images/linkedin.svg';
import Twitter from '../images/twitter.svg';
import './Footer.css';
function Footer() {
    var Year = new Date().getFullYear();
    return(
        <footer class="innovly-footer">
        <div class="container">
            <div class="row">
                <div class="col-lg-3">
                    <div>
                        <img src={Logo} alt="" />

                    </div>
                    <div class="trial-btn">
                        <button>Unlimited trail for 14 days <img src={Trail} alt="trail" /></button>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="footer-mobile">
                        <ul class="footer-main">
                            <li>
                                <div class="footer-menu">
                                    <h3>Effortly</h3>
                                    <ul>
                                        <li><a >Dashboard</a></li>
                                        <li><a >Live View</a></li>
                                        <li><a >Insight</a></li>
                                        <li><a >Map</a></li>
                                        <li><a >Reports</a></li>
                                        <li><a >Settings</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <div class="footer-menu">
                                    <h3>Email Defence</h3>
                                    <ul>
                                        <li><a >Phish defence</a></li>
                                        <li><a >Spam defence</a></li>
                                        <li><a >Email DLP</a></li>
                                        <li><a >Email Encryption</a></li>
                                        <li><a >Attack Simulation</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <div class="footer-menu">
                                    <h3>DLP Defence</h3>
                                    <ul>
                                        <li><a >Device Control</a></li>
                                        <li><a >Application Control</a></li>
                                        <li><a >Encryption</a></li>
                                        <li><a >Browser Control</a></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>

                    </div>

                </div>
                <div class="col-lg-3">
                    <div class="footer-location">
                        <h3>Location</h3>
                        <p>
                            <span class="me-2"><img src={Location} alt="" /></span>Coimbatore, Salem, Erode<br /><span class="ps-3">TN, India.</span>
                        </p>
                        <p>
                            <span class="me-2"><img src={Call} alt="" /></span>+91 8870007553<br />
                        </p>
                    </div>
                </div>
            </div>
            <hr />
            <div class="end-content">
                <div>
                    <ul class="social-icons">
                        <li><NavLink to="/terms">Terms</NavLink></li>
                        <li><NavLink to="/privacy">Privacy</NavLink></li>
                    </ul>
                </div>
                {/* <div>
                    <p>©{Year} Innovly. All rights reserved.</p>
                </div> */}
                <div class="social">
                    <ul class="social-icons">
                        <li><Link to="https://www.youtube.com/channel/UCw_FfXOU1A19kSJWZjiyT9A" target="_blank"><img src={Youtube} alt="" /></Link></li>
                        <li><Link to="https://www.linkedin.com/company/secureforme/" target="_blank"><img src={Linkedin} alt="" /></Link></li>
                        <li><Link to="https://twitter.com/SecureForMe" target="_blank"><img src={Twitter} alt="" /></Link></li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
    );
}
export default Footer;